module.exports = __webpack_public_path__ + "img/resultado-busca.adced326.webp";